const genesisType = ['A', 'B', 'C', 'D'];

export default genesisType;